import { useId } from "react";
import type { QuestionProps } from "../types";
import { choiceInput, choiceRow } from "./choiceStyles";
import { QuestionShell } from "./QuestionShell";

export function MultiChoice(props: QuestionProps) {
  const id = useId();
  const { question, value, onChange, disabled } = props;
  const selected = Array.isArray(value) ? value : [];
  const toggle = (v: string) =>
    onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  return (
    <QuestionShell props={props} inputId={id} asGroup>
      {({ labelId, helpId }) => (
        <div role="group" aria-labelledby={labelId} aria-describedby={helpId} className="flex flex-col gap-2">
          {(question.options ?? []).map((o) => (
            <label key={o.value} className={choiceRow}>
              <input
                type="checkbox"
                className={choiceInput}
                value={o.value}
                checked={selected.includes(o.value)}
                disabled={disabled}
                onChange={() => toggle(o.value)}
              />
              <span className="flex flex-col">
                <span>{o.label}</span>
                {o.help ? <span className="text-sm text-fg-muted">{o.help}</span> : null}
              </span>
            </label>
          ))}
        </div>
      )}
    </QuestionShell>
  );
}
